import i18n from '@/main';

export const configuracaoParametrosTabs = [
    {
        id: 'padrao',
        nome: i18n.t('configuracaoParametros.listagem.tabs.padrao'),
        codigo: 'PADRAO'
    },
    {
        id: 'estado',
        nome: i18n.t('configuracaoParametros.listagem.tabs.estado'),
        codigo: 'ESTADO'
    },
    {
        id: 'fornecedor',
        nome: i18n.t('configuracaoParametros.listagem.tabs.fornecedor'),
        codigo: 'FORNECEDOR'
    }
];

export const tiposExececao = [
    {
        id: 0,
        label: i18n.t('configuracaoParametros.formulario.labelTodoEstado'),
        value: true
    },
    {
        id: 1,
        label: i18n.t('configuracaoParametros.formulario.labelRaio'),
        value: false
    }
];
